export const enum ESpeedBonusActions {
    toggleIsLoading = '@speedBonus/connection/toggleIsLoading',
    toggleIsShowConnection = '@speedBonus/connection/toggleIsShowConnection',
    setBusinessLogic = '@speedBonus/connection/setBusinessLogic',
    setTariff = '@speedBonus/connection/setTariff',
    goToNextStep = '@speedBonus/connection/goToNextStep',
    setRouters = '@speedBonus/connection/setRouters',
    incrementQuantity = '@speedBonus/connection/incrementQuantity',
    decrementQuantity = '@speedBonus/connection/decrementQuantity',
    setRoutersPrice = '@speedBonus/connection/setRoutersPrice',
    setConnectionCost = '@speedBonus/connection/setConnectionCost',
    setTimeSlotData = '@speedBonus/connection/setTimeSlotData',
    setResult = '@speedBonus/connection/setResult',
    flushState = '@speedBonus/connection/flushState',
}
